/*
    機械コードを選択するリスト
*/
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { GetProcs } from "../../models/GetProcs";

export type MachCodeSelectProp = {
  // ラベル
  label: string;
  // 工場コード
  plantCode: string;
  // 加工コード
  procCode: string;
  // 選択中の機械コード
  selectMachCode: string;
  // 機械コードが選択された場合のイベント処理
  handleMachCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  // 特定の機械コードのみ選択可能にしたい場合はfilterに機械コードのリストをセット
  filter?: string[];
};

interface Option {
  code: string;
  name: string;
}

export const MachCodeSelect: React.FC<MachCodeSelectProp> = ({
  label,
  plantCode,
  procCode,
  selectMachCode,
  handleMachCodeChange,
  filter = [],
}) => {
  // このコンポーネントでユニークなID
  const id =
    "select-mach-code-" +
    new Date().getTime().toString(16) +
    Math.floor(1000 * Math.random()).toString(16);
  // 工場・加工・機械マスタデータ
  const plant_proc_mach = useSelector(
    (state: RootState) => state.procs.plantProcMach
  );
  const procs: GetProcs[] = plant_proc_mach.filter(
    (d) => d.plant_code === plantCode && d.proc_code === procCode
  );
  let filterMachCodes: Option[] = [];
  if (procs.length > 0) {
    filterMachCodes = procs[0].mach.map((d) => {
      return { code: d.mach_op_code, name: d.mach_name };
    });
  }
  // 特定の機械コードのみ選択可能にする処理
  if (filter.length > 0) {
    filterMachCodes = filterMachCodes.filter((d) => filter.includes(d.code));
  }

  return (
    <>
      {label !== "" ? <label htmlFor={id}>{label}</label> : null}
      <select
        id={id}
        onChange={handleMachCodeChange}
        value={selectMachCode}
        className="input-110"
      >
        <option value="">-</option>
        {filterMachCodes.map(({ code, name }, index) => (
          <option key={index} value={code}>{`${code}: ${name}`}</option>
        ))}
      </select>
    </>
  );
};
